import { Actions } from '../../../Views/EventPage/EventPage'
import { VenueCardWithQuickDecline, VenueCard } from '../../Material/Card/Card'
import { MatchedAtChip } from '../../Material/Card/CardStyles'
import { DeclinedAtChip } from '../../Material/Chips/SentAtChip'
import {
  DirectEnquiryMessageCardFragment,
  MatchedVenueCardFragment,
  VenueCardFragment,
  DeclinedMessageCardFragment,
} from './VenueCards.generated'

export const MatchedVenueCard = (
  props: MatchedVenueCardFragment
): JSX.Element => {
  const { matchedAt, enquiry, recommended, message } = props
  const { name, tour3dUrl, imageUrl, nearestTransit } = message?.venue ?? {}
  const { uuid } = enquiry ?? {}

  if (!name) throw new Error('venue name could not be found')
  if (!imageUrl) throw new Error('venue images cannot be found')
  if (!matchedAt) throw new Error('Match information cannot be found')
  if (!uuid) throw new Error('no UUID found')

  return (
    <VenueCard
      fit={message?.relevancyFit}
      uuid={uuid}
      interestId={props.id}
      location={nearestTransit?.station}
      name={name}
      has3d={!!tour3dUrl}
      recommended={recommended}
      imageUrl={imageUrl}
      buttonText='View venue'
      timestampChip={<MatchedAtChip matchedDate={matchedAt} />}
    />
  )
}

export const MessageVenueCard = ({
  interest,
  actions,
  isTouchScreen,
  size,
}: {
  interest: VenueCardFragment
  actions: Actions
  isTouchScreen: boolean
  size?: 'small' | 'large'
}): JSX.Element => {
  const { recommended, message, enquiry, id } = interest
  const {
    venue,
    creationDate,
    seenAt,
    id: messageId,
    relevancyFit,
  } = message ?? {}
  const { name, tour3dUrl, imageUrl, nearestTransit } = venue ?? {}
  const { uuid } = enquiry ?? {}

  if (!name) throw new Error('venue name could not be found')
  if (!imageUrl) throw new Error('venue images cannot be found')
  if (!creationDate) throw new Error('Match information cannot be found')
  if (!uuid) throw new Error('no UUID found')
  if (!messageId) throw new Error('no messageId found')

  return (
    <VenueCardWithQuickDecline
      fit={relevancyFit}
      uuid={uuid}
      interestId={id}
      location={nearestTransit?.station}
      name={name}
      has3d={!!tour3dUrl}
      recommended={recommended}
      showNewTag={!seenAt}
      handleQuickDecline={() => actions.handleQuickDecline(messageId)}
      isTouchScreen={isTouchScreen}
      imageUrl={imageUrl}
      buttonText='View message'
      size={size}
    />
  )
}

export const DirectMessageCard = (
  props: DirectEnquiryMessageCardFragment
): JSX.Element => {
  const { recommended, enquiry, message } = props ?? {}
  const { venue, uuid } = enquiry ?? {}
  const { name, tour3dUrl, imageUrl, nearestTransit } = venue ?? {}

  if (!name) throw new Error('venue name could not be found')
  if (!imageUrl) throw new Error('venue images cannot be found')
  if (!uuid) throw new Error('no UUID found')

  return (
    <VenueCard
      fit={message?.relevancyFit}
      uuid={uuid}
      interestId={props.id}
      location={nearestTransit?.station}
      name={name}
      has3d={!!tour3dUrl}
      recommended={recommended}
      imageUrl={imageUrl}
      buttonText='View venue'
      timestampChip={<></>}
    />
  )
}

export const DeclinedMessageCard = ({
  interest,
  size,
}: {
  interest: DeclinedMessageCardFragment
  size?: 'small' | 'large'
}): JSX.Element => {
  const { recommended, message, enquiry, id } = interest
  const { venue, declinedAt } = message ?? {}
  const { name, tour3dUrl, imageUrl, nearestTransit } = venue ?? {}
  const { uuid } = enquiry ?? {}

  if (!name) throw new Error('venue name could not be found')
  if (!imageUrl) throw new Error('venue images cannot be found')
  if (!uuid) throw new Error('no UUID found')
  if (!declinedAt) throw new Error('declinedAt could not be found')

  return (
    <VenueCard
      className='declined-venue-card'
      fit={message?.relevancyFit}
      uuid={uuid}
      interestId={id}
      location={nearestTransit?.station}
      name={name}
      has3d={!!tour3dUrl}
      recommended={recommended}
      imageUrl={imageUrl}
      timestampChip={<DeclinedAtChip declinedAt={declinedAt} />}
      buttonText='View venue'
      size={size}
    />
  )
}
